const CUSTOM_LINK = "custom-link";

export { CUSTOM_LINK };
//# sourceMappingURL=editorCommandsType.js.map
